module.exports = __webpack_public_path__ + "img/cutter.5f027028.png";